import { useState, useCallback, useEffect } from 'react'
import { observer } from 'mobx-react'
import './PopupView.scss'
import classnames from 'classnames'
import { CloseButton, Grid } from '@tfo/common'

export interface PopupViewProps {
	onCloseClick: Function
}

const PopupView = ({ children, onCloseClick, className, externalHostedOrderFlow }: { children: any, onCloseClick: any, className: any, externalHostedOrderFlow?: boolean }) => {
	const [collapsed, setCollapsed] = useState<boolean>(false)

	const handleKeyUp = useCallback((event) => {
		if (event.key === "Escape") {
			setCollapsed(() => true)
			onCloseClick()
		}

	}, [setCollapsed])

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
		if (!collapsed) {
			window.addEventListener("keyup", handleKeyUp)
		} else {
			window.removeEventListener("keyup", handleKeyUp)
		}

		return () => window.removeEventListener("keyup", handleKeyUp)
	}, [collapsed, handleKeyUp])


	return (
		<div className={classnames('PopupView', className)}>
			<div className={classnames('PopupView__Inner', className + '__Inner')}>
				{!externalHostedOrderFlow &&
					<CloseButton
						className={'PopupView__Close'}
						onClick={() => {
							onCloseClick()
						}}
					/>
				}
				<Grid.GridContainer>
					<Grid.GridWrapper>{children}</Grid.GridWrapper>
				</Grid.GridContainer>
			</div>
		</div>
	)
}

export default observer(PopupView)
